import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RoundButton } from '@/components/UI/RoundButton';
import { getAllFoundersList } from '@/store/actions/founderActions';
import Preloader from '@/components/UI/Preloader';
import SwapPartner from '@/components/SwapPartner';

const FoundersAll = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('founders');
  const [params, setParams] = React.useState({
    page: 1,
    limit: 30,
  });

  const { allList, activeList } = useSelector(state => state.founderStore);

  useEffect(() => {
    dispatch(getAllFoundersList(params));
  }, []);

  const getNext = totalPages => {
    if (params.page < totalPages) {
      const nextPage = params.page + 1;
      dispatch(
        getAllFoundersList(
          {
            ...params,
            page: nextPage,
          },
          true,
        ),
      );

      return setParams(prev => ({ ...prev, page: nextPage }));
    }
  };

  const { page } = params;
  const { data, loading } = allList;
  const isEmpty = !!(data && !data.list.length);
  const haveActiveFounders = !!(activeList.data && activeList.data.total_count > 0);

  return (
    <div className={classnames('founders-all', haveActiveFounders && 'active')}>
      {haveActiveFounders && (
        <h2 className="f-26 f-500">
          {data
            ? t('founders_all.all_awesome_founders_with_count', { count: data.total_count })
            : t('founders_all.all_awesome_founders')}
        </h2>
      )}

      {page === 1 && loading ? (
        <Preloader className="founders-all__preloader" />
      ) : isEmpty ? (
        <div className="founders-all__empty">
          <span className="founders-all__empty-title f-16 f-400">
            {t('founders_all.no_founders_yet')}
          </span>
        </div>
      ) : (
        <div className="founders-all__list">
          {data &&
            data.list &&
            data.list.map(founder =>
              founder ? <SwapPartner key={founder.id} founder={founder} /> : null,
            )}
        </div>
      )}

      {data && page < data.total_pages && (
        <RoundButton
          type="button"
          label={t('founders_all.show_more_founders')}
          className="founders-all__btn"
          onClick={() => getNext(data.total_pages)}
        />
      )}
    </div>
  );
};

export default FoundersAll;
